import React from 'react'
import { t } from 'i18next'

export default function NotFoundPage() {
    return (
        <div>{t('components.notFound')}</div>
    )
}
